<template>
	<div class="chat-principal">

		<div class="content" ref="content">

			<div
				v-for="dia in historicoOrdenado"
				:key="dia.fecha"
			>

				<div class="msg-dia">

					<p>{{ dia.fecha | fecha }}</p>

				</div>

				<ul>

					<li
						v-for="(item, index) in dia.mensajes"
						:key="index"
						:class="[item.system ? 'msg-center' : (item.sender !== user.id ? 'msg-left' : 'msg-right')]"
					>

						<div class="msg-content">

							<p>{{ item.msg }}</p>

							<span>{{ item.time | hora }}</span>

						</div>

					</li>

				</ul>

			</div>

		</div>

		<form class="chat-send" @submit.prevent="send">

			<el-input
				v-model="msg"
				placeholder="Escribe un mensaje aquí"
				autofocus
			/>

			<button><i class="el-icon-s-promotion"></i></button>

		</form>

	</div>
</template>

<script>
	import moment from 'moment'

	moment.locale('es')

	export default {
		name: 'ChatPrincipal',
		props: {
			user: {
				type: Object,
				required: true
			},
			ws: {
				required: true
			},
			partner: {
				type: Object,
				required: true
			}
		},
		data () {
			return {
				historico: [],
				msg: '',
			}
		},
		computed: {

			historicoOrdenado () {

				return this.historico.reduce((o, h) => {

					const fecha = moment(h.time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')

					const dia = o.find(f => f.fecha === fecha)

					if (!dia) o.push({ fecha: fecha, mensajes: [h] })

					else dia.mensajes.push(h)

					return o

				}, [])

			}

		},
		watch: {

			historico: {
				deep: true,
				immediate: true,
				handler () { this.scrollBottom() }
			},

			partner () {

				this.historico = []

				this.ws.sendMsg('historico', this.partner.id)

			}

		},
		created () {

			this.ws.sendMsg('historico', this.partner.id)

			this.ws.onMsg('msg', this.onMsg)

			this.ws.onMsg('historico', this.onHistorico)

		},
		mounted () { this.scrollBottom() },
		beforeDestroy () {

			this.ws.delMsg('msg', this.onMsg)

			this.ws.delMsg('historico', this.onHistorico)

		},
		methods: {

			onHistorico (historial) { this.historico = historial },

			scrollBottom () {

				this.$nextTick(() => {

					this.$refs.content.scrollTop = (parseInt(this.$refs.content.scrollHeight) + 200)

				})
			},

			onMsg (msg) { this.historico.push(msg) },

			send () {

				if(this.msg === '') return

				this.ws.sendMsg('msg', {
					msg: this.msg,
					partner: this.partner.id
				})

				this.msg = ''

			}

		},
		filters: {

			hora (val) { return moment(val, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss') },

			fecha (val) { return moment(val, 'YYYY-MM-DD HH:mm:ss').format('D [de] MMMM YYYY') }

		}
	}
</script>
